/* ---------------------------------------------------------------------------
   The Jesus Peace (V2) pre-order, PW-55. wx-wl-preorder.liquid.

   1. Size and Color: two radio groups. The checked pair resolves to one
      variant from the JSON the section prints; its id goes into the form's
      id input, its price onto the button, its availability onto the button
      state. Prices are formatted by Liquid (money_without_trailing_zeros);
      nothing is formatted here.
   2. Pre-order now: /cart/add.js with the line property _lp (it lands on the
      order, so a Shopify export alone shows which orders came from this page),
      the cart attribute wx_lp as the session-level backup, then straight to
      /checkout. A pre-order is one decision; the cart page would be a second.
      The same pattern as wx-lp.js addToCart, minus the drawer.
   3. The FAQ's term answers copy the filled pre-order terms from the section.
   4. Gift with pre-order (8 Oct 2026): after the Jesus Peace is in the cart, the
      first in-stock variant from the form's data-gift ids (priority order) is
      added too, once per cart, with the line property _gift. Shopify's Buy X
      Get Y discount makes it free at checkout but never adds it itself. A
      sold-out id is skipped; any failure here goes on to checkout without it.

   Without this file the form still posts to /cart/add with return_to=/checkout.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';
  if (window.__wxPoLoaded) return;
  window.__wxPoLoaded = true;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    // --- 3. terms into the FAQ -------------------------------------------
    var src = document.querySelector('[data-wx-po-terms]');
    if (src) {
      [].forEach.call(document.querySelectorAll('[data-wx-po-term]'), function (el) {
        var v = (src.getAttribute('data-' + el.getAttribute('data-wx-po-term')) || '').trim();
        if (v) { el.textContent = v; el.classList.remove('is-pending'); }
      });
    }

    // --- 1 and 2 --------------------------------------------------------
    [].forEach.call(document.querySelectorAll('[data-wx-po]'), function (form) {
      var btn = form.querySelector('[data-wx-po-btn]');
      var label = form.querySelector('[data-wx-po-label]');
      var priceEl = form.querySelector('[data-wx-po-price]');
      var msg = form.querySelector('[data-wx-po-msg]');
      var lp = form.getAttribute('data-lp') || 'jp-v2-preorder';
      var checkout = form.getAttribute('data-checkout') || '/checkout';
      var labelText = label ? label.textContent : 'Pre-order now';
      if (labelText === 'Sold out') labelText = 'Pre-order now';
      var busy = false;
      var giftIds = (form.getAttribute('data-gift') || '').split(',')
        .map(function (x) { return x.trim(); }).filter(Boolean);

      // --- 4. the gift: never blocks the pre-order -------------------------
      function addGift() {
        if (!giftIds.length) return Promise.resolve();
        function tryAt(i) {
          if (i >= giftIds.length) return null;
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(giftIds[i]), quantity: 1, properties: { _gift: lp } }] })
          }).then(function (res) { return res.ok ? null : tryAt(i + 1); });
        }
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            var has = (cart.items || []).some(function (it) { return giftIds.indexOf(String(it.variant_id)) > -1; });
            return has ? null : tryAt(0);
          })
          .catch(function () { /* the pre-order matters, the gift does not block it */ });
      }

      var idInput = form.querySelector('[data-wx-po-id]');
      var variants = [];
      try {
        var vEl = form.querySelector('[data-wx-po-variants]');
        variants = vEl ? JSON.parse(vEl.textContent) : [];
      } catch (err) { variants = []; }
      var groups = [].slice.call(form.querySelectorAll('[data-wx-po-opt]'));

      // The chosen value of each option group, in option order.
      function chosen() {
        return groups.map(function (g) {
          var r = g.querySelector('input[type="radio"]:checked');
          return r ? r.value : null;
        });
      }

      // Size x Color to the one variant with exactly those options.
      function resolve() {
        var c = chosen();
        if (c.indexOf(null) !== -1) return null;
        for (var i = 0; i < variants.length; i++) {
          var o = variants[i].options || [];
          var hit = true;
          for (var k = 0; k < c.length; k++) { if (o[k] !== c[k]) { hit = false; break; } }
          if (hit) return variants[i];
        }
        return null;
      }
      function picked() { return resolve(); }

      function say(text) {
        if (!msg) return;
        msg.textContent = text || '';
        msg.hidden = !text;
        msg.classList.toggle('is-error', !!text);
      }

      function sync() {
        var v = resolve();
        var ok = !!(v && v.available);
        if (idInput && v) idInput.value = v.id;
        if (btn) btn.disabled = !ok || busy;
        if (label) label.textContent = ok ? labelText : (v ? 'Sold out' : 'Choose a size and color');
        if (priceEl) { priceEl.textContent = v ? v.price : ''; priceEl.hidden = !ok; }
        groups.forEach(function (g) {
          var r = g.querySelector('input[type="radio"]:checked');
          [].forEach.call(g.querySelectorAll('label'), function (l) {
            l.classList.toggle('is-selected', !!(r && l.contains(r)));
          });
          var name = g.querySelector('[data-wx-po-name]');
          var note = g.querySelector('[data-wx-po-note]');
          if (name) name.textContent = r ? r.value : '';
          if (note) note.textContent = r ? (r.getAttribute('data-note') || '') : '';
        });
        // Mark the values that have no available variant next to the other choices.
        var c = chosen();
        groups.forEach(function (g, gi) {
          [].forEach.call(g.querySelectorAll('input[type="radio"]'), function (inp) {
            var test = c.slice(); test[gi] = inp.value;
            var any = variants.some(function (x) {
              if (!x.available) return false;
              for (var k = 0; k < test.length; k++) { if (test[k] !== null && x.options[k] !== test[k]) return false; }
              return true;
            });
            inp.closest('label').classList.toggle('is-out', !any);
          });
        });
      }

      /* Hero swap (Lau, 7 Oct): the color loop plays until the visitor picks a
         color; then the film stops and the chosen color's image takes its exact
         box, so nothing on the page moves. Picking a size first leaves the film
         alone; once a color has been picked, size changes keep that color. */
      var hero = document.querySelector('[data-wx-po-hero]');
      var still = hero && hero.querySelector('[data-wx-po-still]');
      var film = hero && hero.querySelector('video');
      var cap = hero && hero.querySelector('[data-wx-po-cap]');
      var heroTitle = form.getAttribute('data-title') || 'Jesus Peace (V2)';
      var stillOn = false;
      var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function showColor(v, colorName) {
        /* Only real photographs take the film's place. The 7 Oct variant images are
           300 to 500 px renders cut from a WhatsApp sheet and blur at hero size, so
           the loop keeps playing (Lau). Photos at 1000 px or more switch this on. */
        if (!hero || !still || !v || !v.image || (v.image_w || 0) < 1000) return;
        if (!stillOn && film) {
          var r = film.getBoundingClientRect();
          if (r.width && r.height) { still.style.width = r.width + 'px'; still.style.height = r.height + 'px'; }
          film.pause();
        }
        var swap = function () {
          still.src = v.image;
          still.alt = heroTitle + ' in ' + colorName.toLowerCase();
          still.hidden = false;
          if (film) film.hidden = true;
          if (cap) cap.textContent = heroTitle + ' in ' + colorName.toLowerCase() + '.';
          if (!calm && still.animate) still.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 380, easing: 'ease-out' });
          stillOn = true;
        };
        var pre = new Image(); pre.onload = swap; pre.onerror = swap; pre.src = v.image;
      }

      form.addEventListener('change', function (e) {
        if (e.target && e.target.type === 'radio') {
          say(''); sync();
          var colorGroup = form.querySelector('.wx-wl-po__opt--color');
          var isColor = !!(colorGroup && colorGroup.contains(e.target));
          if (isColor || stillOn) {
            var v = resolve();
            var colorInput = colorGroup && colorGroup.querySelector('input[type="radio"]:checked');
            if (v) showColor(v, colorInput ? colorInput.value : '');
          }
        }
      });

      form.addEventListener('submit', function (e) {
        var r = picked();
        if (!r) { e.preventDefault(); say('Choose a size and a color first.'); return; }
        if (!r.available) { e.preventDefault(); say('That one is sold out. Choose another size or color.'); return; }
        if (!window.fetch) return;           // old browser: the plain form post does it
        e.preventDefault();
        if (busy) return;
        busy = true; say(''); sync();
        if (label) label.textContent = 'One moment';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(r.id), quantity: 1, properties: { _lp: lp } }] })
        })
          .then(function (res) { return res.json().then(function (d) { return { ok: res.ok, data: d }; }); })
          .then(function (res) {
            if (!res.ok) {
              var d = res.data || {};
              throw new Error(d.description || d.message || 'This size could not be reserved just now.');
            }
            return addGift().then(function () { return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ attributes: { wx_lp: lp } })
            }); }).catch(function () { /* the line property is the record, this is the backup */ });
          })
          .then(function () { window.location.href = checkout; })
          .catch(function (err) {
            busy = false;
            var text = String(err && err.message ? err.message : 'Something went wrong').trim();
            if (!/[.?]$/.test(text)) text += '.';
            say(text + ' Please try again, or write to hello@politeworldwide.com.');
            sync();
          });
      });

      // Back from checkout, a cached page would still say "One moment".
      window.addEventListener('pageshow', function () { busy = false; sync(); });

      sync();
    });
  });
})();
